var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{attrs:{"to":_vm.route}},[_c('span',{class:[_vm.css(), _vm.css(null, _vm.type)]},[_c('AtomIcon',{attrs:{"name":_vm.iconName,"color":"var(--color-rainy)","size":20}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }